import { render, staticRenderFns } from "./CarriageContract.vue?vue&type=template&id=5b252e5d&"
import script from "./CarriageContract.vue?vue&type=script&lang=js&"
export * from "./CarriageContract.vue?vue&type=script&lang=js&"
import style0 from "./CarriageContract.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports